// ============================================================
// Compact facts from the demo history for the `stats-ask` AI task
// (#71). The browser sends them with the question, so the answer can
// only use numbers that the Statistiky views show too.
// ============================================================

import { history, summarize, PILOT_START_INDEX } from '@/data/statsData';
import { carrierScorecard } from '@/data/carrierStats';
import { urgencySummary } from '@/data/urgencyStats';

const r1 = (n) => (n == null ? null : Math.round(n * 10) / 10);
const day = (iso) => iso.slice(0, 10);

function weekly() {
  const weeks = [];
  for (let i = 0; i < history.length; i += 5) {
    const chunk = history.slice(i, i + 5);
    const avg = (key) => r1(chunk.reduce((s, d) => s + d[key], 0) / chunk.length);
    weeks.push({ week: day(chunk[0].date), pilot: chunk[0].pilot, noShows: avg('noShows'), informedPct: avg('informedPct'), parkingTrucks: avg('parkingTrucks') });
  }
  return weeks;
}

export function statsFacts() {
  const s = summarize(history, 30);
  const u = urgencySummary(30);
  return {
    period: { last30From: day(history[history.length - 30].date), to: day(history[history.length - 1].date), pilotStart: day(history[PILOT_START_INDEX].date) },
    kpis30: {
      noShowsPerDay: { now: r1(s.noShows.now), beforePilot: r1(s.noShows.before) },
      informedAt13Pct: { now: r1(s.informedPct.now), beforePilot: r1(s.informedPct.before) },
      parkingTrucksPerNight: { now: r1(s.parkingTrucks.now), beforePilot: r1(s.parkingTrucks.before) },
      followUpsPerDay: r1(s.urgencies.now),
      followUpsAutoPct: r1(s.urgencies.autoPct),
    },
    carriers30: carrierScorecard(30).map(({ carrier, now }) => ({
      name: carrier.name, loadings: now.loadings, noShowPct: r1(now.noShowPct), announcedPct: r1(now.announcedPct),
      outOfHours: now.outOfHours, replyMedianMin: now.replyMedian, onTimePct: r1(now.onTimePct),
    })),
    followUps30: {
      total: u.total, replyPct: r1(u.replyPct), replyMedianMin: u.replyMedian, escalatedPct: r1(u.escalatedPct),
      autoResolved: u.autoResolved, toPlanner: u.toPlanner, savedPlannerHoursPerMonth: r1(u.savedHoursMonth), channelCostCzkPerMonth: Math.round(u.costCzkMonth),
    },
    weekly: weekly(),
  };
}
